import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import './PasswordPolicy.css';

interface Props {
}


const PasswordPolicy: FunctionComponent<Props> = ( props ) => {

  const { t } = useTranslation( [ 'passwordPolicy' ] );

  return (
    <div className="password-policy">
      <p>{ t( 'the-new-password-requires' ) }</p>
      <ul>
        <li>min. <strong>8</strong> { t( 'characters' ) }</li>
        <li>min. <strong>1</strong> { t( 'number' ) }</li>
        <li>min. <strong>1</strong> { t( 'lowercase-letter' ) }</li>
        <li>min. <strong>1</strong> { t( 'uppercase-letter' ) }</li>
      </ul>
    </div>
  );
}

export default PasswordPolicy;
